module.exports = __webpack_public_path__ + "img/Docs2.8c49d7a0.jpg";